import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label, Text, ResponsiveContainer } from 'recharts';
import { colors_reports } from '../../constants/colors_reports';

function InsurableSummary({ data }) {
  return (
    <div className="mt-2">
      <Text x={300} y={30} fontSize={30} fontWeight="bold" textAnchor="middle">
        Resumen de asegurabilidad
      </Text>
      <ResponsiveContainer width="95%" height={400} >
        <BarChart height={400} data={data} layout="vertical" >
          <CartesianGrid strokeDasharray="5 5" />
          <XAxis type="number">
            <Label value='Cantidad' position={'insideBottomRight'} />
          </XAxis>
          <YAxis dataKey="insurable_text" type="category" />
          <Tooltip />
          <Legend />
          <Bar dataKey="total" fill={colors_reports[0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default InsurableSummary;
